import { vuexEventPathGenerator } from '@/utils';
import jwtDecode from 'jwt-decode';
const getterType = {
    bearerToken: 'bearerToken',
    isAuthenticated: 'isAuthenticated',
};
export const authGetterType = vuexEventPathGenerator(getterType, 'auth');
const getter = {
    [getterType.bearerToken]: (state) => `Bearer ${state.accessToken || ''}`,
    [getterType.isAuthenticated]: (state) => {
        try {
            const { exp } = jwtDecode(state.accessToken);
            const now = Math.floor(Date.now() / 1000);
            // 토큰 기한 만료 비교
            if (exp < now) {
                throw new Error('Expired Token');
            }
            return !!state.accessToken;
        }
        catch (error) {
            console.log('isAuthenticated', error);
            return false;
        }
    },
};
export default getter;
